import React from "react";
import styled from "styled-components";
import {
  Paragraph, Strike,
} from "../../style/itf-styled-components";
import {DataHeading3} from "./list";
import BuyButton from "../buy-button";

const Container = styled.div`
  display: grid;
  grid-template-columns: 45fr 15fr 20fr 20fr;
`;

const ListHead = styled(Container)`
  grid-column: 1/5;
`;

const ListBody = styled(ListHead)``;

const HeadItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
`;

const DataRow = styled(ListHead)`
  border-bottom: 1px solid #C8CDD0;
  padding: 10px 0;
  
  :last-child {
    border-bottom: none;
  }
`;

const Data = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  :first-child {
    align-items: flex-start;
  }
  
  :last-child {
    align-items: flex-end;
  }
`;
const PlaceholderHeadItem = styled.div``;



class DesktopList extends React.Component {
  componentDidMount() {
      document.querySelectorAll('.checkOutButton').forEach(button => {
        button.addEventListener('click', function(e) {
          if (typeof window !== "undefined") {
            if (window.fbq != null) {
              window.fbq('track', 'InitiateCheckout');
            }
          }
        }, false)
      })
  }

  render() {
    return (
      <>
        <Container className={this.props.className}>

          <ListHead>
            {this.props.list.head.map((headColumn, index) => (
              !!headColumn.label ? <HeadItem key={index}>{headColumn.label}</HeadItem> : <PlaceholderHeadItem key={index}/>
            ))}
          </ListHead>

          <ListBody>
            {this.props.list.data.map((dataRow, index) => (
              <DataRow key={index}>
                {dataRow.map((data, index) => (
                  <Data key={index}>
                    {{
                      heading3: <DataHeading3>{data.value}</DataHeading3>,
                      paragraph: <Paragraph>{data.value}</Paragraph>,
                      strongParagraph: <Paragraph><strong>{data.value}</strong></Paragraph>,
                      strikeParagraph: <Paragraph><Strike>{data.value}</Strike></Paragraph>,
                      buyButton: <BuyButton className="checkOutButton" button={data.value}/>,
                    }[data.type]}
                  </Data>
                ))}
              </DataRow>
            ))}
          </ListBody>

        </Container>
      </>
    );
  }
}

export default DesktopList;